module.exports = __webpack_public_path__ + "assets/img/lvyuanpian.fc1cc633.png";